export default __webpack_public_path__ + "static/media/shadow_pink.77db76e0.png";